import { Platform } from "react-native";

import { space } from "@/design/tokens";

/** Keep content geometry tied to the actual floating mini-player geometry. */
export const CAST_MINI_PILL_HEIGHT = 68;
/** A floating transport should stay visually connected to the list it controls. */
export const CAST_MINI_CONTENT_GAP = space.lg;

export function getCastMiniBottomOffset(safeAreaBottom: number) {
  return Math.max(safeAreaBottom, space.md);
}

export function getDanceListTrailingSpace() {
  return Platform.OS === "web" ? space.xxxl : space.xl;
}

export function getDanceListBottomInset({
  miniPlayerVisible,
  safeAreaBottom
}: {
  miniPlayerVisible: boolean;
  safeAreaBottom: number;
}) {
  if (!miniPlayerVisible) {
    return safeAreaBottom + getDanceListTrailingSpace();
  }

  return (
    getCastMiniBottomOffset(safeAreaBottom) +
    CAST_MINI_PILL_HEIGHT +
    CAST_MINI_CONTENT_GAP
  );
}
